<template>
  <div class="mainPage">
    <!--仓单系统  -->
    <div class="typeArea">
      <div class="firstWrap">
        <!-- <div class="oneTit">交收系统</div> -->
        <div v-for="(item,i) of tabList" :key="i" :class="i==tabIndex?'activeFirst':''" @click="tabIndex=item.id">
          {{ item.name }}
        </div>
      </div>
      
      <div v-if="tabIndex==0" class="chooseWrap">
        <div class="itemSearch">
          <div class="searchTitle">交易品种</div>
          <el-select
            v-model="search.symbolId"
            popper-class="_whiteSelect"
            size="small"
            placeholder="请选择交易品种"
          >
            <el-option
              v-for="item in commodityOptions"
              :key="item.symbolCode"
              :label="item.symbol"
              :value="item.symbolId"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch">
          <div class="searchTitle">方向</div>
          <el-select
            v-model="search.bsFlag"
            popper-class="_whiteSelect"
            size="small"
            placeholder="请选择方向"
          >
            <el-option
              v-for="item in bsFlagOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="actionSearch">
          <el-button
            class="searchBtn"
            plain
            size="small"
            @click="searchData"
          >查询</el-button>
          <el-button
            class="restBtn"
            size="small"
            @click="restData"
          >重置</el-button>
        </div>
      </div>
      <div v-if="tabIndex==1" class="chooseWrap">
        <div class="actionSearch applyFor">
            <div class="descInfos">去申请更多的交收品种</div>
            <el-button
              class="searchBtn"
              size="small"
              @click="applySelet"
            >申请交收并提货</el-button>
          </div>
      </div>
      <!-- <div v-else class="chooseWrap" style="height:32px;"></div> -->
      <div  v-if="tabIndex != 3" class="orderWrap">
        <div class="twoTabContent">
          <!-- 表单内容 -->
          <orderTabFirst v-if="tabIndex==0" :symbol-id="search.symbolId" :bs-flag="search.bsFlag" :is-search="isSearch" />
          <orderTabTwo v-if="tabIndex==1" :is-search="isSearch" />
          <orderTabThree v-if="tabIndex==2" />
        </div>
      </div>
      <div v-if="tabIndex == 3" class="orderWrap">
        <div class="secondWrap">
          <div v-for="(fourTab,index) of fourTabList" :key="index" :class="fourTabIndex==fourTab.id?'activeSecond':''" @click="fourTabIndex = fourTab.id">{{ fourTab.name }}</div>
        </div>
        <div class="twoTabContent">
          <!-- 表单内容 -->
          <SelectGoods v-if="fourTabIndex==0" ref="faa" /><!-- 选货 -->
          <ShopGoods v-if="fourTabIndex==1" ref="fbb" /> <!-- 铺货 -->
          <MyShopGoods v-if="fourTabIndex==2" ref="fcc" /> <!-- 铺货查询 -->
          <MachQuery v-if="fourTabIndex==3" ref="fdd" /> <!-- 配对查询 -->
        </div>
      </div>
    </div>
    <applayXh ref="applyList" :type="1" @getData="searchData" />
  </div>
</template>
<script>
import orderTabFirst from './settlementTab/orderTabFirst'
import orderTabTwo from './settlementTab/orderTabTwo'
import orderTabThree from './settlementTab/orderTabThree'
import applayXh from './settlementTab/applayXh'
// 铺货相关
import SelectGoods from '@views/myDelivery/tab/MyDlivery/SelectGoods'
import MachQuery from '@views/myDelivery/tab/MyDlivery/MachQuery'
import MyShopGoods from '@views/myDelivery/tab/MyDlivery/MyShopGoods'
import ShopGoods from '@views/myDelivery/tab/MyDlivery/ShopGoods'
export default ({
  components: {
    orderTabFirst,
    orderTabTwo,
    orderTabThree,
    applayXh,
    SelectGoods,
    MachQuery,
    MyShopGoods,
    ShopGoods
  },
  data() {
    return {
      isSearch: false,
      tabIndex: 0,
      search: {
        symbolId: null,
        bsFlag: null
      },
      tabList: [
        { name: '交收列表查询', id: 0 },
        { name: '我的交收申请', id: 1 },
        { name: '交收结果查询', id: 2 }
        // { name: '铺货选货', id: 3 }
      ],
      bsFlagOptions: [
        // {
        //   value: 'A',
        //   label: '全部'
        // },
        {
          value: 'B',
          label: '买'
        },
        {
          value: 'S',
          label: '卖'
        }
      ],
      wareCode: null,
      fourTabIndex: 0,
      fourTabList: [{
        name: '选货',
        id: 0
      }, {
        name: '铺货',
        id: 1
      }, {
        name: '铺货查询',
        id: 2
      }, {
        name: '配对查询',
        id: 3
      }]
    }
  },
  computed: {
    commodityOptions() {
      return this.$store.state.hqData.marketDetails
    }
  },
  methods: {
    applySelet() {
      this.$refs.applyList.showDialog()
    },
    searchData() {
      // 搜索报表
      this.isSearch = true
      setTimeout(() => {
        this.isSearch = false
      }, 1000)
    },
    restData() {
      // 重置报表
      this.search = {
        symbolId: null,
        bsFlag: null
      }
      this.isSearch = true
      setTimeout(() => {
        this.isSearch = false
      }, 1000)
    },
    openReport(index) {
      this.twoTabIndex = index
    },
    openThreeReport(index) {
      this.treeTabIndex = index
    }
  }
})
</script>
<style scoped lang="scss">
.applyFor {
  .descInfos{
    padding-right: 20px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    font-size: 20px;
    color: #666666;
    line-height: 16px;
    margin: 0;
  }
}
</style>
